import * as actions from './actions';

const initState = {
    extendResultInfo: true,
    extendResultForm: false,
    extendingResultsStatusType: '',
    isExtending: false,
    showOkButton: false,
    yearGroupsToBeExtended: {}
};

export default function (state = initState, action) {
    switch (action.type) {
    case actions.VERIFY_EXTEND_RESULT_INFO_SUCCESS: {
        return { ...state,
            currentAcademicYear: action.currentAcademicYear,
            extendingResultsStatusType: action.extendingResultsStatusType
        };
    }

    case actions.SHOW_EXTEND_RESULT_INFO: {
        return { ...state, extendResultForm: false, extendResultInfo: true, showOkButton: action.showOkButton };
    }

    case actions.HIDE_EXTEND_RESULT_INFO:
    case actions.CLOSE_EXTEND_RESULT_ERROR: {
        return { ...state, extendingResultsStatusType: '', showOkButton: false };
    }

    case actions.PROCESS_EXTEND_RESULT_REQUEST: {
        return { ...state, extendResultForm: true, extendResultInfo: false };
    }

    case actions.SET_IDS_TO_EXTEND: {
        return { ...state, yearGroupsToBeExtended: action.yearGroupsToBeExtended };
    }

    case actions.EXTEND_RESULTS: {
        return { ...state, isExtending: true, isSuccess: false, isFail: false };
    }

    case actions.EXTEND_RESULTS_SUCCESS: {
        return { ...state, isExtending: false, isSuccess: true };
    }

    case actions.EXTEND_RESULTS_FAILURE: {
        return { ...state, isExtending: false, isSuccess: false, isFail: true };
    }

    case actions.CLOSE_EXTEND_RESULTS_MODAL: {
        return { ...state, isSuccess: false, isFail: false };
    }

    default:
        return { ...state };
    }
}



// WEBPACK FOOTER //
// ./app/containers/extend-result/reducer.js